module.exports = __webpack_public_path__ + "static/media/ATNLogo.67d0ffcb.png";